declare namespace $ {

	export class $mol_icon_gesture_tap_button extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map